
import { Multiplayer, WebServicesEndpointUrl } from "../../../shared/constants";

let webServicesList: any = null;

export async function getWebServicesList() {
	if (!webServicesList) {
		const abort = new AbortController();
		const timer = setTimeout(() => abort.abort(), Multiplayer.ServicesFetchTimeout);
		try {
			const result = await fetch(WebServicesEndpointUrl, { signal: abort.signal });
			if (!result.ok) {
				throw new Error(`Failed to fetch web services list: ${result.status}`);
			}
			webServicesList = await result.json();
		}
		finally {
			clearTimeout(timer);
		}
	}
	return webServicesList;
}

export function invalidateWebServicesListCache() {
	webServicesList = null;
}